import { render } from "./BankAccountForm.vue?vue&type=template&id=25e0b1d3&ts=true"
import script from "./BankAccountForm.vue?vue&type=script&lang=ts"
export * from "./BankAccountForm.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__